export default "__VITE_ASSET__DpO$6R3z__"